module.exports = __webpack_public_path__ + "img/12.15f9a7e1.png";